import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import CardView from "../../../../../../components/common/CardView";
import Search from "../../../../../../components/Search";
import Table from "../../../../../../components/Table";
import withRouter from "../../../../../../withRouter";
import NavBar from "../../../../../../components/navigation";
import { AttendeesCertificate } from "../print-certificate/AttendeesCertificate";
import BaseFormPage from "../../../../../../base/BaseFormPage";
import TrainingApperancePage from "./TrainingApperancePage";
import TrainingCertificatePage from "../training-certificate/TrainingCertificatePage";
import OfficeFormPresenter from "../../../../../OrganizationaStructure/offices/office-form/OfficeFormPresenter";

class TraingAppearanceForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new OfficeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      count: "",
      object: {},
    };
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("Component did update");
    if (prevState.object !== this.state.object) {
      console.log("State updated", this.state.object);
    }
  }

  getCollectionName() {
    return "management_training";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { training } = this.state.object;

    if (training !== undefined) {
      console.log("TRAININGGGGGGG", training);
    }

    return (
      <>
        <TrainingApperancePage training={training} />
      </>
    );
  }
}

export default withRouter(TraingAppearanceForm);
